module.exports = __webpack_public_path__ + "static/media/backWave19.cec95ec3.svg";